// ── 교회별 "휴대폰 홈 화면에 추가" 아이콘/이름 적용 ──────────────────────────
//
// 이 앱은 CRA로 빌드된 단일 정적 파일(index.html / manifest.json)을 모든 교회가
// 함께 쓴다 — 서버가 교회마다 다른 index.html을 내려줄 수 있는 구조가 아니다.
// 그래서 페이지가 뜬 뒤 자바스크립트로 <link rel="apple-touch-icon">,
// <link rel="manifest">, <meta name="apple-mobile-web-app-title"> 등을
// 그 교회 것으로 바꿔치기하는 방식을 쓴다.
//
// - iOS 사파리의 "홈 화면에 추가"는 manifest.json을 아예 안 읽고, 이 페이지의
//   apple-touch-icon / apple-mobile-web-app-title 값을 그대로 쓴다.
// - 안드로이드 크롬의 "홈 화면에 추가"는 그 시점에 페이지에 연결된
//   manifest(link rel="manifest")를 읽어서 이름/아이콘을 정한다.
// 둘 다 "그 순간 페이지에 붙어있는 값"을 읽어가므로, 방문 직후(교회 정보를 받아온
// 시점)에 값을 바꿔치기해두면 충분하다 — 사용자가 실제로 브라우저 메뉴에서
// "홈 화면에 추가"를 누르기까지는 그보다 훨씬 뒤이기 때문이다.

let lastManifestBlobUrl = null;

function upsertLink(rel, href) {
  if (!href) return;
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
}

function upsertMeta(name, content) {
  if (!content) return;
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}

// data:image/svg+xml;base64,... (superAdminController.js가 자동 생성하는 파비콘) 나
// 업로드된 png/jpg URL 모두 올 수 있어서 확장자로 mime type을 최대한 추정한다.
function guessMimeType(src) {
  if (src.startsWith('data:')) {
    const m = /^data:([^;,]+)/.exec(src);
    return m ? m[1] : 'image/png';
  }
  if (/\.svg($|\?)/i.test(src)) return 'image/svg+xml';
  if (/\.(jpe?g)($|\?)/i.test(src)) return 'image/jpeg';
  return 'image/png';
}

// church: { name_ko, name_en, favicon_url } — portal/me, registration/church/:id 등에서 내려주는 형태
export function applyChurchBranding(church, opts = {}) {
  if (!church) return;
  const name = (opts.lang === 'en' ? (church.name_en || church.name_ko) : church.name_ko) || '할라크';
  const icon = church.favicon_url;

  document.title = `할라크 — ${name}`;
  upsertMeta('apple-mobile-web-app-title', name);

  if (icon) {
    upsertLink('icon', icon);
    upsertLink('apple-touch-icon', icon);
  }

  // 안드로이드/크롬용 매니페스트를 그 자리에서 만들어 Blob URL로 교체
  try {
    const mime = icon ? guessMimeType(icon) : 'image/png';
    const manifest = {
      short_name: name,
      name,
      icons: icon
        ? [
            { src: icon, type: mime, sizes: '192x192', purpose: 'any' },
            { src: icon, type: mime, sizes: '512x512', purpose: 'any' },
            { src: icon, type: mime, sizes: '192x192', purpose: 'maskable' },
          ]
        : [
            { src: '/icon-192.png', type: 'image/png', sizes: '192x192', purpose: 'any' },
            { src: '/icon-512.png', type: 'image/png', sizes: '512x512', purpose: 'any' },
          ],
      display: 'standalone',
      theme_color: '#534AB7',
      background_color: '#534AB7',
    };
    const blobUrl = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/json' }));
    upsertLink('manifest', blobUrl);
    if (lastManifestBlobUrl) URL.revokeObjectURL(lastManifestBlobUrl);
    lastManifestBlobUrl = blobUrl;
  } catch {
    // Blob/URL.createObjectURL이 막힌 아주 오래된 브라우저 — 기본 매니페스트 그대로 둠
  }
}

// 로그아웃 등으로 특정 교회 컨텍스트를 벗어날 때 기본 "할라크" 브랜딩으로 복원
export function resetChurchBranding() {
  document.title = '할라크';
  upsertMeta('apple-mobile-web-app-title', '할라크');
  upsertLink('icon', '/favicon-32.png');
  upsertLink('apple-touch-icon', '/apple-touch-icon.png');
  upsertLink('manifest', '/manifest.json');
  if (lastManifestBlobUrl) { URL.revokeObjectURL(lastManifestBlobUrl); lastManifestBlobUrl = null; }
}
